import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "./help_hints";
import "./css/wepcg_bar.css"

class FaultyOptionsUnderWarrantyBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Return Request (Faulty Options Under Warranty)</strong></h1>
            <p>
                This claim type is used for return requests for faulty standalone options under warranty. Options purchased as part of a bundle part number need to be claimed as other warranty service claims via call centre.
            </p>
            <p>
                Please specify the part number, original invoice and expected credited unit price and also please attach any back-up documentation and your references for return and credit note. Due to the nature of this claim type please consolidate the returned items and make a return request on a monthly basis.
            </p>
            <p>
                Make sure the collection details are correct. Contact person should be aware of the incident so our logistics provider can contact them and arrange details of the actual collection. Please have the goods ready for collection. Please contact our financial claims team in case there is any question or problem. Be informed you will be contacted by TNT team per mail with link to TNT tool. Please fill in all required data into TNT tool accordingly (weights, dimensions, number of pallets/boxes and requested delivery date), this will help us to speed up return of goods.
            </p>
            <Help_hints />
        </div>
    }
}

export default FaultyOptionsUnderWarrantyBar;